import { useState, useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";
import '../translate';
import '../translate/translate';
import '../styles/ProfileModal.css';
import { useAuth } from "../providers/AuthProvider.jsx";
import { t } from 'i18next';

function DepositBid({setIsDepositBidOpen, depositAmount, depositMethod, depositWallet, depositExpiredAt, depositDetailId }) {

    const [timeLeft, setTimeLeft] = useState("");
    const fileInputRef = useRef(null);
    const [fileName, setFileName] = useState("");
    const [file, setFile] = useState(null); // Сохраняем выбранный файл
    const [uploadStatus, setUploadStatus] = useState(""); // Для отображения статуса загрузки
    const [isLoading, setIsLoading] = useState(false)

    const [responseModal, setResponseModal] = useState(false);
    const [responseState, setResponseState] = useState(false);
    const [responseText, setResponseText] = useState("")

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
          setFileName(selectedFile.name); // Отображаем имя файла
          setFile(selectedFile); // Сохраняем файл для отправки
        }
      };
      const handleButtonClick = () => {
        fileInputRef.current.click(); // Открываем стандартное окно выбора файла
      };

      const handleUpload = async () => {
        if (!file) {
          setUploadStatus("No file selected!");
          return;
        }
        setIsLoading(true)
        const formData = new FormData();
        formData.append("file", file); // Добавляем файл в FormData
        formData.append("depositDetailId", depositDetailId);
    
        try {
          const response = await fetch(`${import.meta.env.VITE_API_URL}/payment-uploads`, {
            method: "POST",
            body: formData, // Отправляем FormData
          });
    
          if (response.ok) {
            const data = await response.json();
            setUploadStatus("File uploaded successfully!");
            
                setIsLoading(false)
                setResponseState(true)
                setResponseText(`${t("mp_deposit_bid_text")}`)
                setResponseModal(true)
            
          } else {
            setUploadStatus("Failed to upload file.");
          }
        } catch (error) {
          console.error("Error uploading file:", error);
          setUploadStatus("Error uploading file.");
        }
      };

    const getRemainingTime = (expiredAt) => {
        const now = new Date();
        const differenceInMs = new Date(expiredAt) - now; // Разница в миллисекундах
    
        if (differenceInMs <= 0) {
            // setIsDepositBidOpen(false)
            return "0 min : 0 sec"; // Если время истекло
        }
    
        const minutes = Math.floor(differenceInMs / (1000 * 60)); // Полные минуты
        const seconds = Math.floor((differenceInMs % (1000 * 60)) / 1000); // Оставшиеся секунды
    
        return `${minutes} min : ${seconds} sec`;
    };


    
    

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(getRemainingTime(depositExpiredAt))
        }, 1000)
        return () => clearInterval(timer); //
    }, [depositExpiredAt])

    const formatStringNumber = (str) => {
        // Преобразуем строку в число
        const number = parseFloat(str.replace(/\s/g, ''));
        // Форматируем число
        return new Intl.NumberFormat('ru-RU', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(number);
    };

    const handleCopy = () => {
        let valueToCopy = ''
        if(depositMethod === 'humo' || depositMethod === "payme") {
            valueToCopy = import.meta.env.VITE_HUMO_CARD;
        } else if(depositMethod === 'click' || depositMethod === "uzcard") {
            valueToCopy = import.meta.env.VITE_UZCARD_CARD;
        } else if(depositMethod === "usdt trc20") {
            valueToCopy = "TJ6FUUdFzDwh4vPdEdaG7qAjY8c9rCD3qg"
        }
        if (valueToCopy) {
          navigator.clipboard
            .writeText(valueToCopy)
            .then(() => {
              alert("Karta raqami nusxalandi: " + valueToCopy); // Уведомление
            })
            .catch((err) => {
              console.error("Nusxalashda xatolik yuz berdi:", err);
            });
        } else {
          console.warn("Переменная VITE_HUMO_CARD не определена.");
        }
        
    }

    const handleCopyAmount = () => {
        const valueToCopy = depositAmount; // Получаем значение переменной
        if (valueToCopy) {
          navigator.clipboard
            .writeText(valueToCopy)
            .then(() => {
              alert("O'tkaziladigan summa nusxalandi: " + valueToCopy); // Уведомление
            })
            .catch((err) => {
              console.error("Nusxalashda xatolik yuz berdi:", err);
            });
        } else {
          console.warn("Переменная VITE_HUMO_CARD не определена.");
        }
    }



    function ResponseModal({setIsWithdrawOpen, responseText, responseState }) {

        return (
            <div className={'response-modal-wrapper'}>
                <img width={40} src={responseState ? "/assets/img/main/success-icon.svg" : "/assets/img/main/error-icon.svg"} alt="" />
                <p className={'response-modal-title'}>{responseState ? `${t("mp_success")}` : `${t("mp_error")}`}</p>
                <p>
                    {responseText}
                </p>
                <div className={`response-modal-button ${responseState ? "green" : "red"}`} onClick={() => {
                    if(responseState) {
                        setIsWithdrawOpen(false)
                    }
                    
                    setResponseModal(false)
                }}>OK</div>
            </div>
        )
    }




    return (
        <div className={'profile-modal-wrapper'}>
            <div className={'profile-modal-container'}>
                <img className={'profile-modal-close-button'} src="/assets/img/main/close_button.svg" alt="" onClick={() => setIsDepositBidOpen(false)}/>
                <div className={'profile-modal-title'}>
                    <span>Deposit</span>
                </div>
                <div className={'deposit-bid-title-text'}>
                    {t("mp_the_request_was_successfully")}
                </div>
                <div className={'deposit-bid-guarantee'}>
                    <img src="/assets/img/main/guarantee.svg" alt="" />
                    <p><span>{t("mp_this_transfer_guarantees")}</span>{t("mp_this_transfer_guarantees2")}</p>
                </div>
                <div className={'deposit-bid-method-wrap'}>
                    <p>Method</p>
                    <p>{depositMethod.toUpperCase()}</p>
                </div>
                <div className={'deposit-bid-method-wrap text'}>
                    <p>{t("mp_copy_the_exact")}</p>
                </div>
                <div className={'deposit-bid-method-wrap amount'}>
                    <div className={'deposit-bid-amount-transfer'}>
                        <span>{t("mp_amount_to_transfer")}</span>
                        <p>{depositWallet.toUpperCase()} {formatStringNumber(depositAmount)} </p>
                    </div>
                    <div style={{"cursor": "pointer"}} onClick={handleCopyAmount}>
                        <img src="/assets/img/main/copy.svg" alt="" />
                    </div>
                </div>
                <div className={'deposit-bid-method-wrap amount'}>
                    <div className={'deposit-bid-amount-transfer'}>
                        <span>{t("mp_card_number_to_transfer")}</span>
                        {depositMethod === "humo" && <p>{import.meta.env.VITE_HUMO_CARD}</p>}
                        {depositMethod === "uzcard" && <p>{import.meta.env.VITE_UZCARD_CARD}</p>}
                        {depositMethod === "payme" && <p>{import.meta.env.VITE_HUMO_CARD}</p>}
                        {depositMethod === "click" && <p>{import.meta.env.VITE_UZCARD_CARD}</p>}
                        {depositMethod === "usdt trc20" && <p style={{'overflow': 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', 'width': "200px"}}>TJ6FUUdFzDwh4vPdEdaG7qAjY8c9rCD3qg</p>}
                    </div>
                    <div style={{"cursor": "pointer"}} onClick={() => handleCopy()}>
                        <img src="/assets/img/main/copy.svg" alt="" />
                    </div>
                </div>
                <div className={'deposit-bid-method-wrap amount'} onClick={() => {
                        handleButtonClick()
                    }}>
                    <div className={'deposit-bid-amount-transfer'}>
                        <span className={'deposit-bid-font-size-14'}>{fileName ? fileName : `${t("mp_upload_payment_receipt")}`}</span>
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: "none" }} // Полностью скрываем input
                            onChange={handleFileChange}
                        />
                    </div>
                    <div style={{"cursor": "pointer"}}>
                        <img src="/assets/img/main/download-square-icon.svg" alt="" />
                    </div>
                </div>
                <div className={'deposit-bid-method-wrap amount'}>
                    <div className={'deposit-bid-amount-transfer'}>
                        <span>{t("mp_waiting_transfer")}</span>
                        {/* <p>15 min : 00 sec</p> */}
                        <p>{timeLeft}</p>
                        
                    </div>
                    <div>
                        <img className={'deposit-bid-loader'} src="/assets/img/main/loading.svg" alt="" />
                    </div>
                </div>
                <div className={'deposit-bid-paid-button'} onClick={() => {
                    handleUpload()
                    if(!file) {
                        setResponseState(false)
                        setResponseText(`${t("mp_upload_payment_receipt")}`)
                        setResponseModal(true)
                    }
                }}>
                    {t("mp_paid")}
                </div>
                {isLoading && <div className={'modal-loader-wrapper'}>
                        <img src="/assets/img/main/loading.svg" alt="" />
                    </div>}
            </div>
            {responseModal && <div className={'profile-modal-wrapper'}><ResponseModal setIsWithdrawOpen={setIsDepositBidOpen} responseText={responseText} responseState={responseState} /></div>}
        </div>
    )
}

export default DepositBid;